export default function ServicesHero() {
  return (
    <section className="relative h-[420px] md:h-[520px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=premium%20residential%20villa%20development%20architectural%20planning%20Bengaluru%20India%20modern%20luxury%20homes%20aerial%20view%20lush%20green%20landscape%20wide%20angle%20professional%20photography&width=1440&height=520&seq=services-hero-01&orientation=landscape"
          alt="Urban Infra Services"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1B2A4A]/80 via-[#1B2A4A]/60 to-[#1B2A4A]/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8">
        <nav className="flex items-center gap-2 text-white/70 text-sm mb-6">
          <a href="/" className="hover:text-white transition-colors cursor-pointer">Home</a>
          <i className="ri-arrow-right-s-line text-[#7FBF3F]"></i>
          <span className="text-white font-medium">Services</span>
        </nav>

        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white/80 text-xs font-medium px-4 py-1.5 rounded-full mb-5">
            <i className="ri-building-2-line"></i>End-to-End Real Estate Services
          </div>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
            Our Services
          </h1>
          <p className="text-white/85 text-base md:text-lg leading-relaxed max-w-xl">
            From land planning to premium residential development, we create spaces designed for long-term value and trust across Bengaluru.
          </p>
        </div>
      </div>
    </section>
  );
}
